module.exports = "/images/hand.svg?49e93b086cd5107f03989c1b8040a5b9";